import type React from "react";

import { Lightning02Icon } from "@/components/Icons/Lightning02Icon";

import type { ButtonBaseProps } from "./Button";
import { Button } from "./Button";

type AIButtonProps = Pick<
  ButtonBaseProps,
  "children" | "onClick" | "disabled" | "data-testid" | "isLoading" | "className"
> & {
  type?: "button" | "submit";
};
export function AIButton({ children, type = "button", ...otherProps }: AIButtonProps): React.ReactNode {
  return (
    <Button
      styling="ai"
      icon={<Lightning02Icon />}
      {...{
        ...otherProps,
        type,
      }}
    >
      {children}
    </Button>
  );
}
